import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import RouteStack from "./config/RouteStack";

function App() {
  return <RouteStack />;
}

export default App;
